module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /app/~/babel-runtime/core-js/get-iterator.js
// module id = ../../../../babel-runtime/core-js/get-iterator.js
// module chunks = 7